export default __webpack_public_path__ + "static/media/catWindow@2x.35dfe4ab.png";